import React, { Component, PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

class TransactionType extends Component {

  constructor(props) {
    super(props);
    this.state = {
      option: [],
      isDataLoaded: false
    }
  }

  componentWillMount() {

  }

  render() {
    return (
      <FormGroup controlId="transactionType">
        <Col componentClass={ControlLabel} sm={5}>
          Transaction Type *
        </Col>
        <Col sm={7}>
                <select
                  className="custom-select"
                  id="transactionType"
                  onChange={this.props.handleChangeTransactionType}
                  value={this.props.transactionType}
                  required
                >
                  <option value="">Please select</option>
                  <option value="newBusiness">New Business</option>
                  <option value="extension">Extension</option>
                  <option value="endorsement">Endorsement</option>
                  <option value="renewal">Renewal</option>
                </select>
        </Col>
      </FormGroup>
    )
  }
}

TransactionType.propTypes = {
  handleChangeTransactionType: PropTypes.func,
  transactionType: PropTypes.string
};

export default TransactionType;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/transactionType/TransactionType.js